import {useMemo} from "react";
import {useSelector} from "react-redux";
import {css} from "@panda/css";

import {FaqSection, IFaqQuestion} from "@pg-mono/faq";
import {upperFirst} from "@pg-mono/nodash";
import {priceFormat, priceM2Format} from "@pg-mono/string-utils";

import {IRPStore} from "../../../../app/rp_reducer";
import {PRICES_ADDRESS_FAQ_QUESTIONS} from "../../constants/prices_address_faq_questions";
import {getRoomsFlatCostVerb, getRoomsFlatsLabelWhere, getRoomsTypicalFlatLabel} from "../../constants/prices_address_rooms";
import {RoomsFilter} from "../../constants/rcn_rooms_filter";
import {useRcnLatestStats} from "../../hooks/use_rcn_latest_stats";
import {useRcnPeriodStats} from "../../hooks/use_rcn_period_stats";
import type {IPricesAddress} from "../../types/IPricesAddress";
import {formatRcnPointPeriodWithPreposition} from "../../utils/format_rcn_period_label";

interface Props {
    address: IPricesAddress;
    rooms: RoomsFilter;
}

export const PricesAddressFAQ = (props: Props) => {
    const {address, rooms} = props;

    const faq = useSelector((store: IRPStore) => store.faq.data);

    const districtRegion = address.district;

    const perM2Stats = useRcnLatestStats(address.rcnAddress, rooms, "per_m2");
    const perM2 = perM2Stats.point;
    const total = useRcnLatestStats(address.rcnAddress, rooms, "total").point;
    // Same period and grain as the building's point - the same read the comparison chart makes, so both agree.
    const districtPerM2 = useRcnPeriodStats(districtRegion?.id ?? null, rooms, "per_m2", perM2?.period_start ?? null, perM2Stats.grain).point;

    const questions = useMemo(() => {
        const generated: IFaqQuestion[] = [];

        if (perM2) {
            const totalSentence = total
                ? ` ${upperFirst(getRoomsTypicalFlatLabel(rooms))} ${getRoomsFlatCostVerb(rooms)} ${priceFormat(Math.round(total.value), {precision: 0})}.`
                : "";
            // "z 2025 r." already ends the sentence - a second full stop would read "r..".
            const period = formatRcnPointPeriodWithPreposition(perM2);
            const periodSentenceEnd = period.endsWith(".") ? period : `${period}.`;

            generated.push(
                createQuestion(
                    `Ile płacono za metr kwadratowy pod adresem ${address.name}?`,
                    `Mediana ceny transakcyjnej ${getRoomsFlatsLabelWhere(rooms)} pod adresem ${address.name} to ${priceM2Format(Math.round(perM2.value), {precision: 0})}. To mediana z ${perM2.n_rows} transakcji zapisanych w aktach notarialnych, ${periodSentenceEnd}${totalSentence}`
                )
            );
        }

        if (perM2 && districtRegion && districtPerM2) {
            const difference = Math.round(perM2.value) - Math.round(districtPerM2.value);
            const districtPrice = priceM2Format(Math.round(districtPerM2.value), {precision: 0});

            const comparison =
                difference === 0
                    ? `kosztuje tyle samo, co mediana dla ${districtRegion.name_declension_what} (${districtPrice})`
                    : `jest o ${priceFormat(Math.abs(difference), {precision: 0})} ${difference < 0 ? "tańszy" : "droższy"} niż mediana dla ${districtRegion.name_declension_what} (${districtPrice})`;

            generated.push(
                createQuestion(
                    `Czy pod adresem ${address.name} jest drożej niż ${districtRegion.name_declension_where}?`,
                    `Metr ${getRoomsFlatsLabelWhere(rooms)} pod adresem ${address.name} ${comparison}. Obie liczby pochodzą z aktów notarialnych, więc porównujemy kwoty faktycznie zapłacone, a nie ceny z ogłoszeń.`
                )
            );
        }

        return [...generated, ...PRICES_ADDRESS_FAQ_QUESTIONS];
    }, [address.name, rooms, perM2, total, districtRegion, districtPerM2]);

    return <FaqSection faqContent={faq} genericFaqTitle="Najczęstsze pytania" genericQuestions={questions} className={containerStyle} />;
};

const createQuestion = (name: string, answer: string): IFaqQuestion => ({name, answer, answer_text: answer});

const containerStyle = css({
    py: 3,
    mb: 0,
    maxWidth: "1168px",

    md: {
        py: 4
    }
});
import {useMemo} from "react";
import {useSelector} from "react-redux";
import {css} from "@panda/css";

import {FaqSection, IFaqQuestion} from "@pg-mono/faq";
import {upperFirst} from "@pg-mono/nodash";
import {priceFormat, priceM2Format} from "@pg-mono/string-utils";

import {IRPStore} from "../../../../app/rp_reducer";
import {PRICES_ADDRESS_FAQ_QUESTIONS} from "../../constants/prices_address_faq_questions";
import {getRoomsFlatCostVerb, getRoomsFlatsLabelWhere, getRoomsTypicalFlatLabel} from "../../constants/prices_address_rooms";
import {RoomsFilter} from "../../constants/rcn_rooms_filter";
import {useRcnLatestStats} from "../../hooks/use_rcn_latest_stats";
import {useRcnPeriodStats} from "../../hooks/use_rcn_period_stats";
import type {IPricesAddress} from "../../types/IPricesAddress";
import {formatRcnPointPeriodWithPreposition} from "../../utils/format_rcn_period_label";

interface Props {
    address: IPricesAddress;
    rooms: RoomsFilter;
}

export const PricesAddressFAQ = (props: Props) => {
    const {address, rooms} = props;

    const faq = useSelector((store: IRPStore) => store.faq.data);

    const districtRegion = address.district;

    const perM2Stats = useRcnLatestStats(address.rcnAddress, rooms, "per_m2");
    const perM2 = perM2Stats.point;
    const total = useRcnLatestStats(address.rcnAddress, rooms, "total").point;
    // Same period and grain as the building's point - the same read the comparison chart makes, so both agree.
    const districtPerM2 = useRcnPeriodStats(districtRegion?.id ?? null, rooms, "per_m2", perM2?.period_start ?? null, perM2Stats.grain).point;

    const questions = useMemo(() => {
        const generated: IFaqQuestion[] = [];

        if (perM2) {
            const totalSentence = total
                ? ` ${upperFirst(getRoomsTypicalFlatLabel(rooms))} ${getRoomsFlatCostVerb(rooms)} ${priceFormat(Math.round(total.value), {precision: 0})}.`
                : "";
            // "z 2025 r." already ends the sentence - a second full stop would read "r..".
            const period = formatRcnPointPeriodWithPreposition(perM2);
            const periodSentenceEnd = period.endsWith(".") ? period : `${period}.`;

            generated.push(
                createQuestion(
                    `Ile płacono za metr kwadratowy pod adresem ${address.name}?`,
                    `Mediana ceny transakcyjnej ${getRoomsFlatsLabelWhere(rooms)} pod adresem ${address.name} to ${priceM2Format(Math.round(perM2.value), {precision: 0})}. To mediana z ${perM2.n_rows} transakcji zapisanych w aktach notarialnych, ${periodSentenceEnd}${totalSentence}`
                )
            );
        }

        if (perM2 && districtRegion && districtPerM2) {
            const difference = Math.round(perM2.value) - Math.round(districtPerM2.value);
            const districtPrice = priceM2Format(Math.round(districtPerM2.value), {precision: 0});

            const comparison =
                difference === 0
                    ? `kosztuje tyle samo, co mediana dla ${districtRegion.name_declension_what} (${districtPrice})`
                    : `jest o ${priceFormat(Math.abs(difference), {precision: 0})} ${difference < 0 ? "tańszy" : "droższy"} niż mediana dla ${districtRegion.name_declension_what} (${districtPrice})`;

            generated.push(
                createQuestion(
                    `Czy pod adresem ${address.name} jest drożej niż ${districtRegion.name_declension_where}?`,
                    `Metr ${getRoomsFlatsLabelWhere(rooms)} pod adresem ${address.name} ${comparison}. Obie liczby pochodzą z aktów notarialnych, więc porównujemy kwoty faktycznie zapłacone, a nie ceny z ogłoszeń.`
                )
            );
        }

        return [...generated, ...PRICES_ADDRESS_FAQ_QUESTIONS];
    }, [address.name, rooms, perM2, total, districtRegion, districtPerM2]);

    return <FaqSection faqContent={faq} genericFaqTitle="Najczęstsze pytania" genericQuestions={questions} className={containerStyle} />;
};

const createQuestion = (name: string, answer: string): IFaqQuestion => ({name, answer, answer_text: answer});

const containerStyle = css({
    py: 3,
    mb: 0,
    maxWidth: "1168px",

    md: {
        py: 4
    }
});
